// components/ActionRequiredTableRow.tsx
import { FC, useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { TodoDataProps } from "src/pages/actionDashboard/types";
import { format } from "date-fns";
import { AuthContext } from "src/context/authContext";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import WidgetWithTooltip from "../WidgetTooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props {
  data: TodoDataProps;
  refreshListing: () => void;
  index: number
}

const ActionRequiredTableRow: FC<Props> = ({ data, refreshListing, index }) => {
  const { isManufacturer } = useContext(AuthContext);
  const formatDate = (date: string) => (date ? format(new Date(date), "MM/dd/yyyy") : "");
  const toggleIconRef = useRef<HTMLElement | null>(null);
  const [_, changeInfoIconIndex] = useState<number>(-1);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  return (
    <tr>
      {/* Patient Name */}
      <td className="text-center align-middle">
      {data.patient_name !== "Redacted" && data.patient_initials_dob ? (
        <Link to={`/global_patients/${data.patient_id}/${data.bi_case_id}`}>
          {data.patient_initials_dob}
        </Link>
      ) : (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>SF submitted is outdated</Tooltip>}
        >
          <i className="fas fa-info-circle text-color-yellow" style={{ color: "#f2ba45" }}></i>
        </OverlayTrigger>
      )}
    </td>

      {/* Patient ID */}
      {/* <td className="text-center align-middle">
        <Link
          to={`/global_patients/${data.patient_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.patient_id}
        </Link>
      </td> */}

      {/* Case ID */}
      <td className="text-center align-middle">
        <Link
          to={`/cases/detail/${data.bi_case_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.original_id}
        </Link>
      </td>
      <td className="text-center align-middle">
        {data.received_at ? formatDate(data.received_at) : ""}

      </td>
      {/* Reverification */}
      <td className="text-center align-middle">
        {data.clinical_received}

      </td>
      {/* <td className="text-center align-middle">
      {data.reverification && (
        <span className={`${data.reverification.toLowerCase() === "new" ? "" : ""}`}>
          {data.reverification}
        </span>
      )}
    </td> */}

      <td className="text-center align-middle">
        {data.lomn_received}
      </td>

        <td className="text-center align-middle">
          {data.review_type}
        </td>
        <td className="text-center align-middle">
                    {data.qty}
                </td>
                <td className="text-center align-middle">
                    {data.refills}
                </td>

      {/* Date Completed */}
      <td className="text-center align-middle">
        {isManufacturer ? formatDate(data.bi_completed) : data.bi_completed}
      </td>
      <td className="text-center align-middle">
                    {data.pa_required}
                </td>
                

      {/* Insurance/Payer */}
      <td className="text-center align-middle">
        {data.insurance_type}
      </td>

      {/* Missing Information */}
      <td className="text-center align-middle">
        {Number(data.missing_info) === 1 ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{data.missing_info_text}</Tooltip>}
          >
            <span>
              <i
                className="fas fa-info-circle text-color-yellow"
                style={{ color: "#f2ba45" }}
              ></i>
            </span>
          </OverlayTrigger>
        ) : (
          "N"
        )}
      </td>

       <td className="text-center align-middle">
        {data.released}
      </td>

       

      {/* <td className="text-center align-middle">
        {data.region}
      </td>
      <td className="text-center align-middle">
        {data.territory}
      </td>
      <td className="text-center align-middle">
        {data.state}
      </td> */}

      {/* Medical Coverage */}
      {/* <td className="text-center align-middle">
        <span className={`badge ${data.medical_coverage_status_color !== 5 ? "text-white" : ""} background-color-${data.medical_coverage_status_color}`}>
          {data.medical_coverage_status}
        </span>
      </td> */}
      {/* <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>
    </td> */}

      {/* Pharmacy Coverage */}
      <td className="text-center align-middle">
        <span className={`badge ${data.pharmacy_coverage_status_color}`}>
          {data.pharmacy_coverage_status}
        </span>
      </td>
       <td className="text-center align-middle">
          <WidgetWithTooltip caseId={data.bi_case_id} physician={data.physician ?? ""} practice={data.practice ?? {}} />
        </td>
      {/* <td className="text-center fw-bold align-middle">
        {data.next_steps ? data.next_steps.next_step_verbiage || "" : ""}
      </td> */}
    </tr>
  );
}


export default ActionRequiredTableRow;
